import Workspace from "../../service/workspace";
import {
  HANDLE_EDIT_JOB,
  HANDLE_PIPELINE_LIST,
  SET_JOB_DETAILS,
  OPEN_CONFIRM,
  CLOSE_CONFIRM,
  OPEN_STOP_CONFIRM,
  CLOSE_STOP_CONFIRM,
  OPEN_CONFLICT_CONFIRM,
  CLOSE_CONFLICT_CONFIRM,
} from "./types";

const DATA_MODELING_JOBS = [1, 4, 5, 6];

export const handleEditJob = (payload) => {
  return {
    type: HANDLE_EDIT_JOB,
    payload,
  };
};

export const handlePipelineList = (payload) => {
  return {
    type: HANDLE_PIPELINE_LIST,
    payload,
  };
};

export const saveJobDetails = (payload) => {
  return {
    type: SET_JOB_DETAILS,
    payload,
  };
};

export const openConfirm = (payload) => {
  return {
    type: OPEN_CONFIRM,
    payload,
  };
};

export const closeConfirm = () => {
  return {
    type: CLOSE_CONFIRM,
  };
};

export const openStopConfirm = (payload) => {
  return {
    type: OPEN_STOP_CONFIRM,
    payload,
  };
};

export const closeStopConfirm = () => {
  return {
    type: CLOSE_STOP_CONFIRM,
  };
};

const openConflictConfirm = (payload) => {
  return {
    type: OPEN_CONFLICT_CONFIRM,
    payload,
  };
};

export const closeConflictConfirm = () => {
  return {
    type: CLOSE_CONFLICT_CONFIRM,
  };
};

export const handleJobRun = (Workspace_id, Job_id, JobType, validate = true) => {
  return async (dispatch) => {
    const wsService = new Workspace();

    let response = null;
    if (JobType === 2) response = await wsService.runDataExchangeJob(Workspace_id, Job_id);
    else if (JobType === 3) response = await wsService.runDataTranformJob(Workspace_id, Job_id);
    else if (JobType === 7) response = await wsService.runNotebookJob(Workspace_id, Job_id);
    else if (JobType === 8) response = await wsService.runRoutingJob(Workspace_id, Job_id);
    else if (JobType === 9) response = await wsService.runNotificationJob(Workspace_id, Job_id);
    else response = await wsService.dataloadJob("init", Workspace_id, Job_id, JobType, validate);

    if (response.success) {
      if (response.data?.conflict) {
        dispatch(closeConfirm());
        dispatch(openConflictConfirm({ Job_id, JobType, data: response.data }));
      } else {
        if (DATA_MODELING_JOBS.includes(JobType)) {
          if (validate) dispatch(closeConfirm());
          else dispatch(closeConflictConfirm());
        }
        return response;
      }
    }
  };
};

export const handleJobStop = (Workspace_id, Job_id, JobType) => {
  return async (dispatch) => {
    const wsService = new Workspace();
    const response = await wsService.stopJobExecutionById(Workspace_id, Job_id, JobType);

    dispatch(closeStopConfirm());
    return response;
  };
};
